'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _clientLogger = require('./clientLogger');

var _clientLogger2 = _interopRequireDefault(_clientLogger);

var _serverLogger = require('./serverLogger');

var _serverLogger2 = _interopRequireDefault(_serverLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLogger = function createLogger(_ref) {
    var server = _ref.server,
        client = _ref.client;

    return global.__SERVER__ ? (0, _serverLogger2.default)(server) : (0, _clientLogger2.default)(client);
};

exports.default = createLogger;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/logger/index.js
// module id = JcK0
// module chunks = 57